var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _rect2, _path10, _path11, _path12, _path13, _circle, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignCollectors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "undraw_Edit_photo_re_ton4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 179,
    height: 126,
    viewBox: "0 0 179 126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    d: "M223.679,280.947V159.265a2,2,0,0,1,2-2h175a2,2,0,0,1,2,2V280.947a2,2,0,0,1-2,2h-175A2,2,0,0,1,223.679,280.947Z",
    transform: "translate(-223.679 -156.944)",
    fill: "#33333b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    "data-name": "Path 2251",
    d: "M223.679,280.947V159.265a2,2,0,0,1,2-2h175a2,2,0,0,1,2,2V280.947a2,2,0,0,1-2,2h-175A2,2,0,0,1,223.679,280.947Zm2-122.88a1.2,1.2,0,0,0-1.2,1.2V280.947a1.2,1.2,0,0,0,1.2,1.2h175a1.2,1.2,0,0,0,1.2-1.2V159.265a1.2,1.2,0,0,0-1.2-1.2Z",
    transform: "translate(-223.679 -157.268)",
    fill: "#707070"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "feda1070-6288-4949-b833-330f4749d65f",
    d: "M344.165,187.137a1.587,1.587,0,1,1,0,3.175h-39.8a1.588,1.588,0,1,1-.052-3.175h39.852Z",
    transform: "translate(-234.752 -174.724)",
    fill: "#e4e4e4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "feda1070-6288-4949-b833-330f4749d65f-2",
    "data-name": "feda1070-6288-4949-b833-330f4749d65f",
    d: "M344.165,411.822a1.587,1.587,0,1,1,0,3.175h-39.8a1.588,1.588,0,1,1-.052-3.175h39.852Z",
    transform: "translate(-269.89 -306.363)",
    fill: "#efefef"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "feda1070-6288-4949-b833-330f4749d65f-3",
    "data-name": "feda1070-6288-4949-b833-330f4749d65f",
    d: "M552.165,266.807a1.587,1.587,0,1,1,0,3.175h-39.8a1.588,1.588,0,0,1-.052-3.175h39.852Z",
    transform: "translate(-391.448 -221.406)",
    fill: "#707070"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "feda1070-6288-4949-b833-330f4749d65f-4",
    "data-name": "feda1070-6288-4949-b833-330f4749d65f",
    d: "M552.165,293.807a1.587,1.587,0,1,1,0,3.175h-39.8a1.588,1.588,0,0,1-.052-3.175h39.852Z",
    transform: "translate(-391.448 -237.215)",
    fill: "#707070"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "feda1070-6288-4949-b833-330f4749d65f-5",
    "data-name": "feda1070-6288-4949-b833-330f4749d65f",
    d: "M552.165,320.807a1.587,1.587,0,1,1,0,3.175h-39.8a1.588,1.588,0,0,1-.052-3.175h39.852Z",
    transform: "translate(-391.448 -253.024)",
    fill: "#707070"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2254",
    "data-name": "Path 2254",
    d: "M547.3,354.9a5.435,5.435,0,1,1,5.435,5.435A5.435,5.435,0,0,1,547.3,354.9Z",
    transform: "translate(-412.808 -269.821)",
    fill: "#fe6502"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2255",
    "data-name": "Path 2255",
    d: "M554.462,358.239h1.608v-1.608a.536.536,0,1,1,1.072,0v1.61h1.608a.536.536,0,0,1,0,1.072h-1.608v1.608a.536.536,0,0,1-1.072,0v-1.608h-1.608a.536.536,0,0,1,0-1.072Z",
    transform: "translate(-416.68 -273.69)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3128",
    "data-name": "Rectangle 3128",
    width: 84.424,
    height: 0.534,
    transform: "matrix(0.773, -0.634, 0.634, 0.773, 25.027, 84.81)",
    fill: "#707070"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3129",
    "data-name": "Rectangle 3129",
    width: 0.534,
    height: 84.594,
    transform: "matrix(0.636, -0.772, 0.772, 0.636, 25.035, 31.704)",
    fill: "#707070"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2256",
    "data-name": "Path 2256",
    d: "M281.73,284.533V233.01a1.871,1.871,0,0,1,1.869-1.869h63.537A1.871,1.871,0,0,1,349,233.01v51.524a1.871,1.871,0,0,1-1.869,1.869H283.6A1.871,1.871,0,0,1,281.73,284.533Zm1.869-52.858a1.336,1.336,0,0,0-1.335,1.335v51.524a1.336,1.336,0,0,0,1.335,1.335h63.537a1.336,1.336,0,0,0,1.335-1.335V233.01a1.336,1.336,0,0,0-1.335-1.335Z",
    transform: "translate(-257.605 -200.583)",
    fill: "#707070"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2257",
    "data-name": "Path 2257",
    d: "M265.468,307.016V255.493a1.871,1.871,0,0,1,1.869-1.869h63.537a1.871,1.871,0,0,1,1.869,1.869v51.523a1.871,1.871,0,0,1-1.869,1.869H267.337A1.871,1.871,0,0,1,265.468,307.016Z",
    transform: "translate(-248.101 -213.766)",
    fill: "#fe6502"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2258",
    "data-name": "Path 2258",
    d: "M328.965,317.934H361.4a.658.658,0,0,0,.121-.01l-15.341-26.573a1.074,1.074,0,0,0-1.87,0l-10.3,17.833-.493.853Z",
    transform: "translate(-285.21 -235.494)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    "data-name": "Path 2259",
    d: "M105.286,186.51h11.075l-5.437-7.9-.391-.569-.2-.284-.493.853Z",
    transform: "translate(-61.531 -104.093)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2260",
    "data-name": "Path 2260",
    d: "M285.506,328.946h28.056l-5.437-7.9-.391-.569-7.084-10.291a1.433,1.433,0,0,0-2.128-.127,1.281,1.281,0,0,0-.1.127Z",
    transform: "translate(-259.812 -246.517)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_324",
    "data-name": "Ellipse 324",
    cx: 4.805,
    cy: 4.805,
    r: 4.805,
    transform: "translate(42.034 52.576)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3130",
    "data-name": "Rectangle 3130",
    width: 5.873,
    height: 5.873,
    transform: "translate(75.297 43.662)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignCollectors);
export default __webpack_public_path__ + "static/media/assign_collectors.8759f5c83774a94d56e5794a577ffcb2.svg";
export { ForwardRef as ReactComponent };